import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filterPropType } from '../utils/propTypes';
import CheckboxFilter from './CheckboxFilter';
import SelectFilter from './SelectFilter';
import ToggleFilter from './ToggleFilter';
const propTypes = {
  /**
   * Currently active filter values
   */
  activeValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  /**
   * Object that defines a filter
   */
  filter: filterPropType.isRequired,
  /**
   * Called when the filter value is changed
   */
  onFilterChange: PropTypes.func.isRequired,
  /**
   * Registers this filter with the root DataGrid component
   */
  onRegisterFilter: PropTypes.func.isRequired
};
const DEFAULT_CHECKBOX_LABEL = 'All';
export default class DataGridFilter extends Component {
  constructor(props) {
    super(props);
    this.handleCheckboxChange = (label, isChecked) => {
      const {
        filter,
        onFilterChange
      } = this.props;
      let valuesToApply = [...this.state.valuesToApply];
      if (label === DEFAULT_CHECKBOX_LABEL) {
        // deselect all items
        valuesToApply = [];
      } else if (isChecked) {
        // deselect this item
        valuesToApply.splice(valuesToApply.indexOf(label), 1);
      } else {
        // select this item
        valuesToApply.push(label);
      }
      this.setState({
        valuesToApply
      });
      onFilterChange(filter, valuesToApply);
    };
    this.handleSelectChange = event => {
      const {
        filter,
        onFilterChange
      } = this.props;
      const values = event.target.value ? [event.target.value] : [];
      onFilterChange(filter, values);
    };
    this.handleToggleChange = (label, isChecked) => {
      const {
        filter,
        onFilterChange
      } = this.props;
      let valuesToApply = [...this.state.valuesToApply];
      if (isChecked) {
        valuesToApply.splice(valuesToApply.indexOf(label), 1);
      } else {
        valuesToApply.push(label);
      }
      this.setState({
        valuesToApply
      });
      onFilterChange(filter, valuesToApply);
    };
    this.state = {
      valuesToApply: [...props.activeValues]
    };
  }
  componentDidMount() {
    const {
      activeValues,
      filter,
      onRegisterFilter
    } = this.props;
    onRegisterFilter(filter, activeValues);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.activeValues !== this.props.activeValues) {
      this.setState({
        valuesToApply: [...this.props.activeValues]
      });
    }
  }
  render() {
    const {
      activeValues,
      filter
    } = this.props;
    const {
      valuesToApply
    } = this.state;
    if (filter.type === 'checkbox') {
      return /*#__PURE__*/React.createElement(CheckboxFilter, {
        defaultLabel: DEFAULT_CHECKBOX_LABEL,
        filter: filter,
        valuesToApply: valuesToApply,
        onChange: this.handleCheckboxChange
      });
    } else if (filter.type === 'toggle') {
      return /*#__PURE__*/React.createElement(ToggleFilter, {
        activeValues: activeValues,
        filter: filter,
        valuesToApply: valuesToApply,
        onChange: this.handleToggleChange
      });
    } else {
      return /*#__PURE__*/React.createElement(SelectFilter, {
        defaultLabel: DEFAULT_CHECKBOX_LABEL,
        activeValues: activeValues,
        filter: filter,
        onChange: this.handleSelectChange
      });
    }
  }
}
DataGridFilter.propTypes = propTypes;
DataGridFilter.defaultProps = {
  activeValues: []
};